import React, {useEffect, useState} from 'react';
import "./Login.scss"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faLongArrowAltLeft} from '@fortawesome/free-solid-svg-icons'
import {motion, useAnimation} from "framer-motion";
import {Link} from "react-router-dom";

let easing = [0.6, -0.05, 0.01, 0.99];

const fadeInUp = {
    initial: {
        y: 30,
        opacity: 0,
        transition: {duration: 0.6, ease: easing}
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: easing
        }
    },
    hover: {
        opacity: 0.8,
        x: -10
    },
};

const Login = ({login}) => {
    const controls = useAnimation();

    const [username, setUsername] = useState();
    const [password, setPassword] = useState();

    const submitValue = () => {
        const loginDetails = {
            'username': username,
            'password': password,
        };
        login(loginDetails);
    };

    return (
        <motion.div initial='initial' animate='animate' exit={{opacity: 0}} className="container__login">
            <div className="box-login">
                <div className="login-container">
                    <div className="left-content__login">
                        <div className="title__login">Area Privata</div>
                        <div className="logo__login">
                            <img src={require('./../assets/images/bg_login.jpg')} width="" height="300px" alt=""/>
                        </div>
                    </div>
                    <div className="right-content__login">
                        <form className="div__form__login">
                            <motion.div className="div__input__login" animate={controls} variants={fadeInUp} initial="initial">
                                <input className="form__input__login secondary__input" placeholder="Username" type="text" onChange={e => setUsername(e.target.value)}/>
                                <input className="form__input__login secondary__input" placeholder="Password" type="password" onChange={e => setPassword(e.target.value)}/>
                            </motion.div>
                            <motion.div className="btn__secondary button__login" style={{marginTop: 60}} animate={controls} variants={fadeInUp}
                                        initial="initial" onClick={submitValue}>
                                <div className="btn__secondary--background"></div>
                                <div className="btn__secondary--text">
                                    <div>Entra</div>
                                </div>
                            </motion.div>
                            <motion.div variants={fadeInUp} whileHover="hover" className="div__back__login">
                                <Link to="/" style={{textDecoration: 'none'}}>
                                    <FontAwesomeIcon icon={faLongArrowAltLeft} className="icon__back__login"/><a className='go-back__login'>Torna
                                    indietro</a>
                                </Link>
                            </motion.div>
                        </form>
                    </div>
                </div>
            </div>
        </motion.div>
    )
};

export default Login;
